import React, { useState, useEffect } from 'react';
import {
	Wrapper,
	ImageContainer,
	TextContainer,
	Text,
	Title,
	Help,
	ProgressWrapper,
	ProgressBarBackground,
	ProgressBarMarker,
	StyledButton,
} from './TaxonomyApplication.styles';
import { UploadStateContext } from 'contexts/UploadStateContext';
import { ApSignalrConsumer } from '@alixpartners/ui-utils';
import { DIRECT_TAXONOMY_STATUS } from 'Data/constants';
import { getApplyDataFromTree } from '../utils';
import {
	fetchTaxonomyMapperData,
	applyTaxonomyDirect,
} from 'utils/apiRequests';

const defaultMessage = 'The new taxonomy is being applied to your spend data';
const failedMessage =
	'Taxonomy application has failed, please try to apply taxonomy again';

export const TaxonomyApplication = ({ status, refetch }) => {
	const [progress, setProgress] = useState(0);
	const [hasFailed, setHasFailed] = useState(false);
	const [message, setMessage] = useState(defaultMessage);

	const handleProcessing = (_messageName, statusMessage, percentage) => {
		setProgress(percentage);
		setMessage(statusMessage);
	};

	const handleComplete = () => {
		refetch();
	};
	const handleFail = () => {
		refetch();
	};
	const handleApplyTaxonomy = async () => {
		const treeData = await fetchTaxonomyMapperData();
		const applyData = getApplyDataFromTree(treeData);

		await applyTaxonomyDirect(applyData);
		refetch();
	};

	useEffect(
		() => {
			setHasFailed(
				status.directApplyTaxonomyState === DIRECT_TAXONOMY_STATUS.FAILED
			);
		},
		[status]
	);

	return (
		<Wrapper>
			<ImageContainer hasFailed={hasFailed} />
			<TextContainer>
				<Title hasFailed={hasFailed}>
					Taxonomy application{hasFailed && ' failed'}
				</Title>
				<Text>{hasFailed ? failedMessage : message}</Text>
				{!hasFailed ? (
					<React.Fragment>
						<ProgressWrapper>
							<ProgressBarBackground>
								<ProgressBarMarker style={{ width: `${progress}%` }} />
							</ProgressBarBackground>
						</ProgressWrapper>
						<Help>Please wait until the process is complete</Help>
					</React.Fragment>
				) : (
					<StyledButton onClick={handleApplyTaxonomy}>
						Apply taxonomy
					</StyledButton>
				)}
			</TextContainer>
			<ApSignalrConsumer
				message="DirectTaxonomyProcessing"
				onMessage={handleProcessing}
			/>
			<ApSignalrConsumer
				message="DirectTaxonomyCompleted"
				onMessage={handleComplete}
			/>
			<ApSignalrConsumer
				message="DirectTaxonomyFailed"
				onMessage={handleFail}
			/>
		</Wrapper>
	);
};

export default props => (
	<UploadStateContext.Consumer>
		{({ status, refetch }) => (
			<TaxonomyApplication status={status} refetch={refetch} {...props} />
		)}
	</UploadStateContext.Consumer>
);
